import { useRef } from "react";
import { useMathJax } from "../../hooks/useMathJax";
import { processText } from "../../utils/learnUtils";

/**
 * Equation tooltip showing symbol meanings and (for multiline) line-by-line descriptions.
 * @param {{ item: object, onClose: () => void }} props
 */
export default function EqTooltipPanel({ item, onClose }) {
  const ref = useRef(null);
  const {
    tooltip_elements = [],
    tooltip_descriptions = [],
    line_descriptions = [],
  } = item?.data ?? {};

  useMathJax(ref, [item?._id]);

  return (
    <div className="eqt" ref={ref}>
      <div className="eqt__header">
        <span className="eqt__title">{item?.title}</span>
        <button className="eqt__close" onClick={onClose} aria-label="Close">
          ✕
        </button>
      </div>

      {tooltip_elements.length > 0 && (
        <section className="eqt__section">
          <h4 className="eqt__section-title">Symbols</h4>
          <dl className="eqt__dl">
            {tooltip_elements.map((el, i) => (
              <div key={i} className="eqt__dl-row">
                <dt className="eqt__dt">{`$${el}$`}</dt>
                <dd
                  className="eqt__dd"
                  dangerouslySetInnerHTML={{
                    __html: processText(tooltip_descriptions[i]) ?? "",
                  }}
                />
              </div>
            ))}
          </dl>
        </section>
      )}

      {line_descriptions.length > 0 && (
        <section className="eqt__section">
          <h4 className="eqt__section-title">Steps</h4>
          {/* <ol className="eqt__steps">
            {line_descriptions.map((desc, i) => (
              <li key={i} className="eqt__step"
                dangerouslySetInnerHTML={{ __html: desc }}
              />
            ))}
          </ol> */}
          <dl className="eqt__dl">
            {line_descriptions.map((el, i) => (
              <div key={i} className="eqt__dl-row">
                {i == 0 ? (
                  <dt className="eqt__dt">{`Line ${i + 1}: `}</dt>
                ) : (
                  <dt className="eqt__dt">{`Lines ${i}-${i + 1}`}</dt>
                )}

                <dd
                  className="eqt__dd"
                  dangerouslySetInnerHTML={{ __html: processText(el ?? "") }}
                />
              </div>
            ))}
          </dl>
        </section>
      )}
    </div>
  );
}

// {content.data.line_descriptions.map((this_element,index) => (
//     <div key={index}>
//         {index===0 ?
//             (<EdCompMarkdown markdown={`Line ${index+1}: ${this_element}`} is_active={true} span={true}/>):
//             (<EdCompMarkdown markdown={`Lines ${index}-${index+1}$\\color{blue}\\rightarrow$ ${this_element}`} is_active={true} span={true}/>)
//         }
//     </div>
// ))}
